export const STACKED_BAR_TEXT = [
  {
    title: 'Distributions of Bills Across Policy Categories',
    description: 'Select a policy category to see the state’s bill count.',
  },
  {
    title: 'Distributions of Bills Across Statuses',
    description: 'Select a bill status to see the bill count.',
  },
];